import { render, staticRenderFns } from "./DriverStatusSelector.vue?vue&type=template&id=fd628f8e&"
import script from "./DriverStatusSelector.vue?vue&type=script&lang=js&"
export * from "./DriverStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatusSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports